import styled from "styled-components"
import image from '../../assets/ArrowDown2.png'

export const Page= styled.div`
  margin: 0px 100px;

  
  @media screen and (max-width: 950px){
    margin: 5px;
  }
`

export const DashContainer = styled.div`
    display: flex;
    background-color: black;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    filter: brightness(${props => props.degree});

  @media screen and (max-width: 400px){
    height: 100%;
  }
  

  @media screen and (max-height: 900px){
    height: 100%;
  }



`

export const DashContent = styled.section`
  color: white;
  margin: 10px 20px;
  text-align: center; 
  display: flex;
  flex-direction: column;
  height: inherit;
`
export const DashHead = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;


`
export const DashHeadCaption = styled.h1`
    color: white;
    font-size: 32px;
    font-weight: bold;
`

export const DashSelectWrapper = styled.div`

`

export const DashInput = styled.select`
  display: flex;
  justify-content: flex-start;
  border: 1px #595959 solid;
  border-radius: 10px;
  width: 381px;
  font-size:16px;
  height: 64px;
  background-color: transparent;
  color: white;
  margin-top: 40px;
  padding: 10px 15px;
  appearance:none;
  -moz-appearance:none;
  -webkit-appearance:none;
  background-image:url(${image}) ;
  background-repeat:no-repeat;
  background-position: 95% 50% ;
  background-size: 20px;
  
  @media screen and (max-width: 950px){
    width: 300px;
  }
  



` 
export const DashTable = styled.div`
  display: flex;
  width: 100%;
  margin-top: 40px;

  @media screen and (max-width: 500px){
    width: inherit;
    margin-top:3vh;
  }

  
`
export const DashInputOption = styled.option`
  color: white;
  background-color:#262626 ;

`
